import styled from "styled-components/macro";

export const Inner = styled.div`
  display: flex;
`;
export const ProductData = styled.div`
  flex: 1 1 60%;
  width: 950px;
`;
